<form [formGroup]="form" (submit)="submit()" class="form">
  <mat-list>
    <div class="search">
      @if (definition?.luceneSearchField !== undefined) {
        <ldw-text-edit
          [form]="form"
          iconName="search"
          [enableToolTip]="false"
          [autofocus]="true"
          [vmp]="definition?.luceneSearchField"
        ></ldw-text-edit>
      }
      <div>
        <button mat-button matTooltip="{{ showToolTip() ? ('SEARCH.START' | translate) : '' }}">
          <mat-icon>play_arrow</mat-icon>
        </button>
        <button
          mat-button
          (click)="scan()"
          type="button"
          matTooltip="{{ showToolTip() ? ('SEARCH.QRCODE' | translate) : '' }}"
        >
          <!-- type="button" prevents submit -->
          <mat-icon>qr_code_scanner</mat-icon>
        </button>
        <button
          mat-button
          (click)="clear()"
          type="button"
          matTooltip="{{ showToolTip() ? ('SEARCH.CLEAR' | translate) : '' }}"
        >
          <!-- type="button" prevents submit -->
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="search-status">
      @if (definition?.docStatusSearchField !== undefined) {
        <ldw-vmp-form-group-item [vmp]="definition?.docStatusSearchField" [captionWidth]="captionWidth">
          <div class="inner-control">
            <ldw-status-select
              #statusSelect
              [form]="form"
              groupName="form"
              controlName="statusField"
              [initialValue]="statusInitialValue"
              [emptyDisplayValue]="'STATUS.ALL' | translate"
            ></ldw-status-select>
          </div>
        </ldw-vmp-form-group-item>
        }
    </div>
    <div class="search">
      <mat-slide-toggle formControlName="useMetaDataField">{{ 'SEARCH.SEARCHMETADATA' | translate }}</mat-slide-toggle>
      <mat-slide-toggle formControlName="useWildCard">{{ 'SEARCH.WILDCARD' | translate }}</mat-slide-toggle>
    </div>
    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" [vertical]="isVerticalPropertyLayout">
      <mat-button-toggle [checked]="showDocNodes" (change)="setShowDocNodes()">{{
        'SEARCH.DOCSTRUCTURE' | translate
      }}</mat-button-toggle>
      @if (hasLoopNodes) {
        <mat-button-toggle [checked]="showLoopNodes" (change)="setShowLoopNodes()">{{
          'SEARCH.PLANTSTRUCTURE' | translate
        }}</mat-button-toggle>
      }
      @if (hasLoopNodes) {
        <mat-button-toggle [checked]="showCustomNodes" (change)="setShowCustomNodes()">{{
          'SEARCH.CUSTOMNAVIGATION' | translate
        }}</mat-button-toggle>
      }
    </mat-button-toggle-group>

    <mat-accordion multi="true">
      @if (showDbSearchField()) {
        <ldw-vmp-form-group
          [captionWidth]="captionWidth"
          [form]="form"
          [vmpList]="getSearchTextDefinition()"
        ></ldw-vmp-form-group>
      }

      @if (showLoopNodes) {
        <ldw-vmp-form-group
          [captionWidth]="captionWidth"
          [form]="form"
          [vmpList]="definition?.loopFields"
        ></ldw-vmp-form-group>
      }

      @if (showLoopNodes) {
        <ldw-vmp-form-group
          [captionWidth]="captionWidth"
          [form]="form"
          [vmpList]="definition?.lncFields"
        ></ldw-vmp-form-group>
      }

      @if (definition?.docFields !== undefined) {
        <ldw-vmp-form-group
          [captionWidth]="captionWidth"
          [form]="form"
          [vmpList]="definition?.docFields"
        ></ldw-vmp-form-group>
      }

      @if (showLoopNodes) {
        <ldw-vmp-form-group
          [captionWidth]="captionWidth"
          [form]="form"
          [vmpList]="definition?.lsnFields"
        ></ldw-vmp-form-group>
      }

      @if (showDocNodes) {
        <ldw-vmp-form-group
          [captionWidth]="captionWidth"
          [form]="form"
          [vmpList]="definition?.nodeFields"
        ></ldw-vmp-form-group>
      }

      @if (showCustomNodes) {
        <ldw-vmp-form-group
          [captionWidth]="captionWidth"
          [form]="form"
          [vmpList]="definition?.customFields"
        ></ldw-vmp-form-group>
      }
    </mat-accordion>
  </mat-list>
  <!-- hidden input required for submit with enter -->
  <button class="hiddenbutton" submit></button>
</form>
